import { render, staticRenderFns } from "./SectionInhibitorFrom2022.vue?vue&type=template&id=2d3b99af"
import script from "./SectionInhibitorFrom2022.vue?vue&type=script&lang=ts"
export * from "./SectionInhibitorFrom2022.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports